import { DownloadBlock } from "./Sections/Download/Download";
import { RegistrationBlock } from "./Sections/Registration/RegistrationBlock";
import { Upsale } from "./Sections/Upsale/Upsale";


const componentMap = {
  RegistrationBlock,
  Upsale,
  DownloadBlock
};
export const RenderRegistrationComponent = ({ boxItem }) => {
  const Component = componentMap[boxItem.type] || null;

  if (!Component) {
    console.warn(`Component not found for type: ${boxItem.type}`);
    return null;
  }

  return <Component />;
};
